import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../store'


import WeightLossFlowTwo from '@/components/WeightLoss/WeightLossFlowTwo.vue';
import reportPage from '@/components/WeightLoss/reportPage.vue';
import choosePlan from '@/components/WeightLoss/choosePlan.vue';
import showStepsToUser from '@/components/WeightLoss/showStepsToUser.vue';

import medIntegration from '@/components/forms/formLoader.vue';
import videoExplainer from '@/components/forms/videoExplainer.vue';

import uploadVideo from '@/components/forms/uploadVideo.vue';

//sorry page
import leadDisqualified from '@/components/common/leadDisqualified.vue';


import prescriptionThanks from '@/components/WeightLoss/WeightLossAfterCheckout.vue';
import verifyPhoneAndEmail from '@/components/WeightLoss/verifyPhoneAndEmail.vue';

import checkoutWeightLoss from '@/components/checkouts/checkoutWeightLoss.vue';
import checkoutCallCenter from '@/components/checkouts/checkoutCallCenter.vue';
import KlarnaReturn from '@/components/checkouts/KlarnaReturn.vue';


import adjustDoases from '@/components/forms/AdjustDoases.vue';
import prescriptionView from '@/components/forms/prescriptionView.vue';


import verifyAddress from '@/components/common/verifyAddress.vue';
//auth
import LoginPage from '@/components/auth/LoginPage.vue';
import ResetPassword from '@/components/auth/ResetPassword.vue'
import ForgotPassword from '@/components/auth/ForgotPassword.vue'

//dashboard - new layout with nested routes
const DashboardShell = () => import('@/components/dashboard/layout/DashboardShell.vue')
const DashboardOverview = () => import('@/components/dashboard/overview/DashboardOverview.vue')
const OrdersPage = () => import('@/components/dashboard/orders/OrdersPage.vue')
const MessagesPage = () => import('@/components/dashboard/messages/MessagesPage.vue')
const ProfilePage = () => import('@/components/dashboard/profile/ProfilePage.vue')
const BillingPage = () => import('@/components/dashboard/billing/BillingPage.vue')
const ReferralsPage = () => import('@/components/dashboard/referrals/ReferralsPage.vue')
const MedicalFormPage = () => import('@/components/dashboard/medical-form/MedicalFormPage.vue')
const UpgradePage = () => import('@/components/dashboard/upgrade/UpgradePage.vue')
const ChangeTreatmentPage = () => import('@/components/dashboard/upgrade/ChangeTreatmentPage.vue')
const MedicalCheckinPage = () => import('@/components/dashboard/checkin/MedicalCheckin.vue')
const VerifyAddressPage = () => import('@/components/dashboard/verify-address/VerifyAddress.vue')

import reshippingRequest from '@/components/reshipping/reshippingRequest.vue'

import embeddablesForm from '@/components/embedForms/embeddablesForm.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  hash: false,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved scroll position (like after navigating back), use it
    if (savedPosition) {
      return savedPosition;
    } else {
      // Otherwise, scroll to the top
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      name: 'WeightLossFlowTwoHome',
      component: WeightLossFlowTwo,
      meta: {
        requiresAuth: false,
        guest: true
      }
      
    },
    {
      path: '/verify',
      name: 'verifyPhoneAndEmail',
      component: verifyPhoneAndEmail,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-report',
      name: 'reportPage',
      component: reportPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-plan',
      name: 'choosePlan',
      component: choosePlan,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/verify-address',
      name: 'verifyAddress',
      component: verifyAddress,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    
    {
      path: '/status-progress',
      name: 'showStepsToUser',
      component: showStepsToUser,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/replacement-request',
      name: 'reshippingRequest',
      component: reshippingRequest,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },    
    {
      path: '/assessment/:id',
      name: 'FormLoader2',
      component: medIntegration,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/upload-video/:id',
      name: 'uploadVideo',
      component: uploadVideo,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/explainer/:id',
      name: 'videoExplainer',
      component: videoExplainer,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/medical-form/:id',
      name: 'QuestionFormLoaderUpdated',
      component: medIntegration,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
   
    {
      path: '/case-questions/:id',
      name: 'medIntegration',
      component: medIntegration,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/medicalform/:id',
      name: 'QuestionFormLoaderUpdated2',
      component: medIntegration,
      props: true,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/prescription/:id',
      name: 'prescriptionView',
      component: prescriptionView,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/adjust-doses/:id',
      name: 'adjustDoases',
      component: adjustDoases,
      meta: {
        requiresAuth: true,
        guest: false
      }
    },
    {
      path: '/flow/:flowId',
      name: 'embeddablesForm',
      component: embeddablesForm,
      meta: {
        requiresAuth: false,
        guest: false
      }
    },
    {
      path: '/checkin/:id',
      redirect: to => `/home/checkin/${to.params.id}${to.fullPath.includes('?') ? '?' + to.fullPath.split('?')[1] : ''}`
    },
    {
      path: '/home',
      component: DashboardShell,
      meta: {
        requiresAuth: true,
        guest: false
      },
      children: [
        {
          path: '',
          name: 'HomePage',
          component: DashboardOverview
        },
        {
          path: 'orders',
          name: 'DashboardOrders',
          component: OrdersPage
        },
        {
          path: 'messages',
          name: 'DashboardMessages',
          component: MessagesPage
        },
        {
          path: 'profile',
          name: 'DashboardProfile',
          component: ProfilePage
        },
        {
          path: 'billing',
          name: 'DashboardBilling',
          component: BillingPage
        },
        {
          path: 'referrals',
          name: 'DashboardReferrals',
          component: ReferralsPage
        },
        {
          path: 'medical-form/:orderId',
          name: 'DashboardMedicalForm',
          component: MedicalFormPage
        },
        {
          path: 'upgrade',
          name: 'DashboardUpgrade',
          component: UpgradePage
        },
        {
          path: 'treatment/change',
          name: 'DashboardChangeTreatment',
          component: ChangeTreatmentPage
        },
        {
          path: 'checkin/:id',
          name: 'DashboardCheckin',
          component: MedicalCheckinPage
        },
        {
          path: 'verify-address',
          name: 'DashboardVerifyAddress',
          component: VerifyAddressPage
        },
      ]
    },
    {
      path: '/sorry',
      name: 'leadDisqualified',
      component: leadDisqualified,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    
    {
      path: '/payment/thanks',
      name: 'prescriptionThanks',
      component: prescriptionThanks,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weightlosspayment/:cart_id',
      name: 'checkoutCallCenter',
      component: checkoutCallCenter,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-payment/:cart_id',
      name: 'checkoutWeightLoss',
      component: checkoutWeightLoss,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weight-loss-payment/:cart_id/klarna-return',
      name: 'KlarnaReturnWeightLoss',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/weightlosspayment/:cart_id/klarna-return',
      name: 'KlarnaReturnCallCenter',
      component: KlarnaReturn,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/password-reset/:token',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiresAuth: false,
        guest: true
      }
    },
    
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Auto-login via token in URL (e.g. /home?token=xxx from external domain redirect)
  const urlToken = to.query.token;
  if (urlToken) {
    // Always strip the token from the URL to avoid leaking it in browser history/bookmarks
    const cleanQuery = { ...to.query };
    delete cleanQuery.token;

    // If already authenticated, just strip the token and continue
    if (store.getters.isAuthenticated) {
      return next({ path: to.path, query: cleanQuery, replace: true });
    }

    try {
      const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
      const response = await axios.get(`${apiEndpoint}/api/current-user-details`, {
        headers: { Authorization: `Bearer ${urlToken}` }
      });

      if (response.data.success && response.data.user) {
        // Only store the token after we've confirmed it's valid
        store.commit('updateAccessToken', urlToken);
        store.commit('updateUserData', response.data.user);
        if (response.data.shipping) {
          store.dispatch('saveShippingDetails', response.data.shipping);
        }
        if (response.data.referralLink) {
          store.dispatch('setReferralLink', response.data.referralLink);
        }
        return next({ path: to.path, query: cleanQuery, replace: true });
      } else {
        return next({ path: '/login' });
      }
    } catch (err) {
      console.error('Auto-login failed:', err);
      return next({ path: '/login' });
    }
  }

  const isAuthenticated = store.getters.authToken !== null;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.authToken == null) {
      // Add the page_ref query parameter with the route name the user was trying to access
      next({
        path: '/login',
        query: {
          page_ref: to.fullPath,
        }
      });
    } else {
      next();
    }
  }else if (to.path === '/login' && isAuthenticated) {
    next('/home');
  } else {
    next();
  }
})

router.afterEach(() => {
  store.dispatch('syncWidgetTheme');
})

export default router;

